import { useMemo } from 'react'
import { useFarmContext } from 'src/Elements/Farm'
import { useSoftwareVersionQueries } from 'src/Libs/home-power-station'
import { areSoftwareVersionsInSync } from '../utils'

type ReturnType = {
  areInSync: boolean
  isLoading: boolean
}

/**
 * Determines whether all farm clients run the same software version. Comparison ignores the
 * product prefix (e.g. "H20_2026_42" and "XCM_2026_42" are considered equal); a single (or no)
 * storage is always considered in sync.
 */
const useAreClientSoftwareVersionsInSync = (): ReturnType => {
  const { farmClients } = useFarmContext()
  const storageIds = useMemo(() => farmClients?.map(client => client.storageId) || [], [farmClients])
  const { softwareVersions, isLoading } = useSoftwareVersionQueries(storageIds)

  const areInSync = useMemo(() => areSoftwareVersionsInSync(softwareVersions.map(({ softwareVersion }) => softwareVersion)), [softwareVersions])

  return { areInSync, isLoading }
}

export default useAreClientSoftwareVersionsInSync
